/**
 * Created by rathompson on 9/14/21
 * File: TableHeader
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import type { VFC } from 'react'
import { Body, Title } from '@panwds/react-ui'
import { useMemo } from 'react'

/***
 * @param title The title for table header
 * @param subtitle optional subtitle
 * @param children right controls
 * @param border
 * @returns {JSX.Element}
 * @constructor
 * @desc Header for tables
 */
// tw-border-solid tw-border-gray-300 tw-flex tw-relative tw-bg-white tw-border dark:tw-bg-blue-steel-1000 dark:tw-border-blue-steel-800 tw-overflow-auto
const TableHeader: VFC<{
  title?: string,
  subtitle?: string,
  children?: any,
  border?: boolean
}> = ({ title, subtitle, children, border = true }) => {

  const borderClasses = useMemo(() => [
    'tw-border',
    'tw-border-l',
    'tw-border-r',
    'tw-border-t',
    'tw-border-b-0',
    'tw-border-solid',
    'tw-rounded-t-lg',
    'tw-border-gray-300',
    'dark:tw-border-gray-950'
  ], [])

  const backgroundClasses = useMemo(() => {
    return [
    ]
  }, [])

  const classNames = useMemo(() => {
    const classNames = [
      'tw-p-3',
      'tw-flex',
      'tw-flex-row',
      'tw-justify-between',
      ...backgroundClasses,
    ]
    if (border) {
      classNames.push(...borderClasses)
    }
    return classNames
  }, [backgroundClasses, border, borderClasses])

  return (
    <div className={classNames.join(' ')} style={{ flexGrow: 'initial' }}>
      <div className='tw-truncate'>
        <Title level={1} size={'xs'} addClassName='tw-flex tw-truncate'>{title}</Title>
        {subtitle && <Body appearance="secondary" addClassName='tw-truncate'>{subtitle}</Body>}
      </div>
      <div className='tw-flex tw-flex-row tw-items-center tw-gap-2'>
        {children}
      </div>
    </div>
  )
}

export default TableHeader
